import { isRouteErrorResponse, useRouteError } from 'react-router';
import { Button, Result } from 'antd';
import { Link } from 'react-router-dom';

/**
 * Props
 * status:number - 错误代码
 */
export default function RouterErrorBoundary(props) {
    const { status = '' } = props;
    const error = useRouteError();

    const renderError = () => {
        const err = isRouteErrorResponse(error) ? error.status : status;
        switch (err) {
            case 404:
                return (
                    <Result
                        status="404"
                        title="404"
                        subTitle="找不到当前访问的页面"
                        extra={
                            <Link to="/login">
                                <Button type="primary">返回首页</Button>
                            </Link>
                        }
                    />
                );
            default:
                return (
                    <Result
                        status="warning"
                        title="警告"
                        subTitle="页面出现了某些错误"
                        extra={
                            <Link to="/login">
                                <Button type="primary">返回首页</Button>
                            </Link>
                        }
                    />
                );
        }
    };

    return <div className="ax-result-page">{renderError()}</div>;
}
